(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  const VISIBLE_COUNT = 3;
  const GAP = 20;

  function equalizeReviewCards(scope = document) {
    const containers = scope.querySelectorAll
      ? scope.querySelectorAll('.sd-reviews__grid, .sd-reviews__track')
      : document.querySelectorAll('.sd-reviews__grid, .sd-reviews__track');

    containers.forEach((container) => {
      const cards = Array.from(container.querySelectorAll('.sd-review-card'));
      cards.forEach((card) => {
        card.style.minHeight = '';
      });

      if (!cards.length) return;

      const maxHeight = Math.max(...cards.map((card) => card.offsetHeight));
      cards.forEach((card) => {
        card.style.minHeight = `${maxHeight}px`;
      });
    });
  }

  class SDReviewsCarousel {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('.sd-reviews__viewport');
      this.track = root.querySelector('.sd-reviews__track');
      this.cards = Array.from(root.querySelectorAll('.sd-review-card'));
      this.prevButton = root.querySelector('.sd-reviews__nav--prev');
      this.nextButton = root.querySelector('.sd-reviews__nav--next');
      this.dotsContainer = root.querySelector('.sd-reviews__dots');
      this.currentIndex = 0;
      this.maxIndex = Math.max(0, this.cards.length - VISIBLE_COUNT);
      this.mqlDesktop = window.matchMedia('(min-width: 990px)');

      if (this.cards.length <= VISIBLE_COUNT) return;

      this.buildDots();
      this.bindEvents();
      equalizeReviewCards(this.root);
      this.goTo(0, false);
    }

    buildDots() {
      if (!this.dotsContainer) return;

      this.dotsContainer.innerHTML = '';

      for (let index = 0; index <= this.maxIndex; index += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sd-reviews__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Aller à l'avis ${index + 1}`);
        dot.addEventListener('click', () => this.goTo(index));
        this.dotsContainer.appendChild(dot);
      }

      this.dots = Array.from(this.dotsContainer.querySelectorAll('.sd-reviews__dot'));
    }

    bindEvents() {
      this.prevButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

      this.onResize = () => {
        equalizeReviewCards(this.root);
        if (this.mqlDesktop.matches) {
          this.goTo(this.currentIndex, false);
        } else if (this.track) {
          this.track.style.transform = '';
        }
      };
      window.addEventListener('resize', this.onResize);

      this.onKeydown = (event) => {
        if (event.key === 'ArrowLeft') this.goTo(this.currentIndex - 1);
        if (event.key === 'ArrowRight') this.goTo(this.currentIndex + 1);
      };

      this.root.addEventListener('keydown', this.onKeydown);
    }

    goTo(index, animate = true) {
      const nextIndex = Math.min(Math.max(index, 0), this.maxIndex);
      this.currentIndex = nextIndex;

      if (!this.mqlDesktop.matches) {
        this.updateControls();
        return;
      }

      if (!this.track || !this.cards[0]) return;

      const cardWidth = this.cards[0].offsetWidth;
      const offset = nextIndex * (cardWidth + GAP);

      if (!animate) {
        this.track.style.transition = 'none';
      }

      this.track.style.transform = `translateX(-${offset}px)`;

      if (!animate) {
        this.track.getBoundingClientRect();
        this.track.style.transition = '';
      }

      this.updateControls();
    }

    updateControls() {
      if (this.prevButton) {
        this.prevButton.disabled = this.currentIndex === 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.currentIndex === this.maxIndex;
      }

      this.dots?.forEach((dot, index) => {
        const isActive = index === this.currentIndex;
        dot.classList.toggle('sd-reviews__dot--active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    destroy() {
      window.removeEventListener('resize', this.onResize);
      this.root.removeEventListener('keydown', this.onKeydown);
    }
  }

  class SDReviewsMobileLoop {
    constructor(section) {
      this.section = section;
      this.scroller = section.querySelector('.sd-reviews__track, .sd-reviews__grid');
      this.active = false;
      this.jumping = false;
      this.clones = [];
      this.originals = [];
      this.settleTimer = null;

      this.mql = window.matchMedia('(max-width: 989px)');
      this.onMedia = () => this.sync();
      this.onScroll = () => {
        if (this.jumping) return;
        window.clearTimeout(this.settleTimer);
        this.settleTimer = window.setTimeout(() => this.settle(), 120);
      };

      if (this.mql.addEventListener) {
        this.mql.addEventListener('change', this.onMedia);
      } else if (this.mql.addListener) {
        this.mql.addListener(this.onMedia);
      }
    }

    sync() {
      if (this.mql.matches) {
        this.enable();
      } else {
        this.disable();
      }
    }

    makeClones() {
      return this.originals.map((card) => {
        const clone = card.cloneNode(true);
        clone.classList.add('sd-review-card--clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, [tabindex]').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        });
        return clone;
      });
    }

    enable() {
      if (this.active || !this.scroller) return;

      this.originals = Array.from(this.scroller.children).filter((el) =>
        el.classList.contains('sd-review-card')
      );

      if (this.originals.length === 0) return;

      this.active = true;

      const leadFragment = document.createDocumentFragment();
      const trailFragment = document.createDocumentFragment();
      const lead = this.makeClones();
      const trail = this.makeClones();

      lead.forEach((clone) => leadFragment.appendChild(clone));
      trail.forEach((clone) => trailFragment.appendChild(clone));

      this.scroller.insertBefore(leadFragment, this.originals[0]);
      this.scroller.appendChild(trailFragment);
      this.clones = lead.concat(trail);

      equalizeReviewCards(this.section);
      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });

      window.requestAnimationFrame(() => this.centerOriginal(0));
    }

    disable() {
      if (!this.active) return;

      this.active = false;
      this.scroller.removeEventListener('scroll', this.onScroll);
      window.clearTimeout(this.settleTimer);

      this.clones.forEach((clone) => clone.remove());
      this.clones = [];
      this.scroller.scrollLeft = 0;

      equalizeReviewCards(this.section);
    }

    centerCard(card) {
      if (!card) return;

      const scrollerRect = this.scroller.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const delta =
        cardRect.left + cardRect.width / 2 - (scrollerRect.left + this.scroller.clientWidth / 2);

      const previous = this.scroller.style.scrollBehavior;
      this.scroller.style.scrollBehavior = 'auto';
      this.scroller.scrollLeft += delta;
      this.scroller.style.scrollBehavior = previous;
    }

    centerOriginal(index) {
      const child = this.scroller.children[this.originals.length + index];
      this.centerCard(child);
    }

    settle() {
      if (!this.active) return;

      const children = Array.from(this.scroller.children);
      const len = this.originals.length;

      if (children.length < len * 3) return;

      const scrollerRect = this.scroller.getBoundingClientRect();
      const center = scrollerRect.left + this.scroller.clientWidth / 2;

      let bestIndex = 0;
      let bestDistance = Infinity;

      children.forEach((child, index) => {
        const rect = child.getBoundingClientRect();
        const distance = Math.abs(rect.left + rect.width / 2 - center);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      const setWidth =
        children[len].getBoundingClientRect().left - children[0].getBoundingClientRect().left;

      if (bestIndex < len) {
        this.jumpBy(setWidth);
      } else if (bestIndex >= len * 2) {
        this.jumpBy(-setWidth);
      }
    }

    jumpBy(delta) {
      if (!delta) return;

      this.jumping = true;
      const previous = this.scroller.style.scrollBehavior;
      this.scroller.style.scrollBehavior = 'auto';
      this.scroller.scrollLeft += delta;
      this.scroller.style.scrollBehavior = previous;

      window.requestAnimationFrame(() => {
        this.jumping = false;
      });
    }

    recenterNearest() {
      const children = Array.from(this.scroller.children);
      if (!children.length) return;

      const scrollerRect = this.scroller.getBoundingClientRect();
      const center = scrollerRect.left + this.scroller.clientWidth / 2;

      let best = null;
      let bestDistance = Infinity;

      children.forEach((child) => {
        const rect = child.getBoundingClientRect();
        const distance = Math.abs(rect.left + rect.width / 2 - center);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = child;
        }
      });

      this.centerCard(best);
    }

    onResize() {
      if (!this.active) return;
      equalizeReviewCards(this.section);
      this.recenterNearest();
    }

    destroy() {
      this.disable();

      if (this.mql.removeEventListener) {
        this.mql.removeEventListener('change', this.onMedia);
      } else if (this.mql.removeListener) {
        this.mql.removeListener(this.onMedia);
      }
    }
  }

  const instances = new WeakMap();
  const mobileLoops = new WeakMap();

  function getSections(scope) {
    const sections = [];

    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('.sd-reviews')) {
      sections.push(scope);
    }

    if (scope && scope.querySelectorAll) {
      scope.querySelectorAll('.sd-reviews').forEach((section) => sections.push(section));
    }

    return sections;
  }

  function setupMobileLoop(section) {
    let loop = mobileLoops.get(section);

    if (!loop) {
      loop = new SDReviewsMobileLoop(section);
      mobileLoops.set(section, loop);
    }

    loop.sync();
  }

  function initCarousel(root) {
    if (!root) return;

    const existing = instances.get(root);
    if (existing) {
      existing.destroy();
      instances.delete(root);
    }

    const instance = new SDReviewsCarousel(root);
    instances.set(root, instance);
  }

  function initAll(scope = document) {
    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-sd-reviews-carousel]').forEach(initCarousel);
    }

    getSections(scope).forEach(setupMobileLoop);
    equalizeReviewCards(scope);
  }

  function onResize() {
    equalizeReviewCards();
    document.querySelectorAll('.sd-reviews').forEach((section) => {
      const loop = mobileLoops.get(section);
      if (loop) loop.onResize();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  window.addEventListener('resize', onResize);

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelectorAll) {
      event.target.querySelectorAll('[data-sd-reviews-carousel]').forEach((root) => {
        const instance = instances.get(root);
        if (instance) {
          instance.destroy();
          instances.delete(root);
        }
      });
    }

    getSections(event.target).forEach((section) => {
      const loop = mobileLoops.get(section);
      if (loop) {
        loop.destroy();
        mobileLoops.delete(section);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
